import type { ReviewType } from '#base/core/types/ReviewType';
import type { UrlType } from '#base/core/types/UrlType';

export const getAggregateScore = (): {
	rating: number;
	totalReviews: number;
	url: UrlType;
} => {
	return {
		rating: 9.2,
		totalReviews: 103,
		url: {
			url: '/',
			title: 'Fysio Hier QualiView pagina',
			newTab: true,
		},
	};
};

export const getReviews = (): ReviewType[] => {
	return [
		{
			rating: 9,
			date: new Date(),
			reviewerName: 'John Doe',
			text: 'Deze fysiopraktijk heeft een professionele en vriendelijke benadering, waardoor ik me altijd comfortabel en veilig voelde tijdens mijn bezoek. De behandeling was goed en effectief.',
			title: 'Professioneel en vriendelijk',
		},
		{
			rating: 9.5,
			date: new Date(),
			reviewerName: 'John Doe',
			text: 'Ik heb een geweldige ervaring gehad bij Fysio Hier. De fysiotherapeuten waren altijd attent en op de hoogte van de laatste ontwikkelingen in de sector. Ze zijn zeer gedreven en bieden een hoogwaardige behandeling. De faciliteiten zijn modern en de prijzen zijn betaalbaar. Ik kan Fysio Hier aan iedereen aanbevelen.',
			title: 'Moderne praktijk',
		},
		{
			rating: 8.7,
			date: new Date(),
			reviewerName: 'John Doe',
			text: 'De klantenservice bij Fysio Hier is uitstekend en de medewerkers zijn zeer professioneel. De behandeling is zorgvuldig en resultaatgericht. Ik ben zeer tevreden met de diensten van Fysio Hier.',
			title: 'Resultaatgericht',
		},
		{
			rating: 8,
			date: new Date(),
			reviewerName: 'John Doe',
			text: 'Deze fysiopraktijk heeft een professionele en vriendelijke benadering, waardoor ik me altijd comfortabel en veilig voelde tijdens mijn bezoek. De behandeling was goed en effectief.',
			title: 'Goede effectieve behandeling',
		},
		{
			rating: 9.2,
			date: new Date(),
			reviewerName: 'John Doe',
			text: 'Ik heb een geweldige ervaring gehad bij Fysio Hier. De fysiotherapeuten waren altijd attent en op de hoogte van de laatste ontwikkelingen in de sector. Ze zijn zeer gedreven en bieden een hoogwaardige behandeling. De faciliteiten zijn modern en de prijzen zijn betaalbaar. Ik kan Fysio Hier aan iedereen aanbevelen.',
			title: 'Geweldige ervaring',
		},
		{
			rating: 10,
			date: new Date(),
			reviewerName: 'John Doe',
			text: 'De klantenservice bij Fysio Hier is uitstekend en de medewerkers zijn zeer professioneel. De behandeling is zorgvuldig en resultaatgericht. Ik ben zeer tevreden met de diensten van Fysio Hier.',
			title: 'Uitstekende klantenservice',
		},
	];
};
